import React, { useState, useEffect } from "react";
import ReactPlayer from "react-player";
import axios from "axios";

const formatTime = (seconds) => {
  const minutes = Math.floor(seconds / 60);
  const remainingSeconds = Math.floor(seconds % 60);
  return `${minutes}:${remainingSeconds < 10 ? "0" : ""}${remainingSeconds}`;
};

const AudioPlayer = ({ url }) => {
  const [playing, setPlaying] = useState(false);
  const [duration, setDuration] = useState(0);
  const [currentTime, setCurrentTime] = useState(0);
  const muted = false;
  const volume = 0.8;

  const downloadAudio = async () => {
    try {
      const response = await axios.get(url, {
        responseType: "arraybuffer", // Alternativa a blob
      });

      const filename = `grabacion-${new Date().toISOString().slice(0, 19).replace(/:/g, "-")}.mp3`;

      const blob = new Blob([response.data], { type: "audio/mpeg" });

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div className="player-wrapper">
      <div className="">
        <ReactPlayer
          url={url}
          playing={playing}
          muted={muted}
          volume={volume}
          onPlay={() => setPlaying(true)}
          onPause={() => setPlaying(false)}
          onDuration={(d) => setDuration(d)}
          onProgress={({ playedSeconds }) => setCurrentTime(playedSeconds)}
          width="0%"
          height="0px"
          controls={false}
        />
        <div className="controls mt-3">
          {playing ? (
            <button
              className="btn btn-sm btn-citoplus-info btn-sm"
              onClick={() => setPlaying(!playing)}
            >
              <i className="fas fa-pause"></i>
            </button>
          ) : (
            <button
              className="btn btn-sm btn-citoplus-primary btn-sm"
              onClick={() => setPlaying(!playing)}
              title="Play Audio"
            >
              <i className="fas fa-play"></i>
            </button>
          )}
          <button
            className="btn btn-citoplus-secondary btn-sm ml-2"
            onClick={downloadAudio}
            title="Download Audio"
          >
            <i className="fas fa-download"></i>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AudioPlayer;
